import React,{useEffect} from "react"

export const PrivacyPolicy  = () => {

  useEffect(() => {
    const link = document.createElement("a");
    link.href = "https://drive.google.com/uc?export=download&id=1wIEVJKBf23lfHPEjyWCT-Jczh6S3tG-N";
    link.download = "AvisoPrivacidad_Wirebit.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  // https://drive.google.com/file/d/1Bmyuvx2HlPpvBF-1YeHQfyekOuQy7QcS/view?usp=sharing

  https://drive.google.com/file/d/1wIEVJKBf23lfHPEjyWCT-Jczh6S3tG-N/view?usp=sharing

  // https://drive.google.com/uc?export=download&id=1wIEVJKBf23lfHPEjyWCT-Jczh6S3tG-N

  return(
    <div style={{display: 'flex', justifyContent: 'center', height: '100vh'}}>
      {/* <div className="embed-responsive embed-responsive-4by3">
        <iframe className="embed-responsive-item" src="/pdf-avisosprivacidad.pdf" width="100%" height="300"></iframe>
      </div> */}

      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <p>Si la descarga no comienza automáticamente, <a href="https://drive.google.com/uc?export=download&id=1wIEVJKBf23lfHPEjyWCT-Jczh6S3tG-N" download>haz clic aquí</a>.</p>
      </div>
    </div>
  )
}